import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Link from './Link';
import styled from 'styled-components';
import { transparentize, darken } from 'polished';

import ScaleToggle from './helpers/ScaleToggle';
import Logo from './Logo';
import { MenuButton } from './Buttons';
import HeaderCartController from '../controllers/HeaderCart.controller';

const StyledMobileNavigation = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  max-width: ${p => p.theme.globalWidthLarge};
  margin: 0 auto;
  padding: 0 ${p => p.theme.gutter};
`;

const Overlay = styled(ScaleToggle)`
  align-items: center;
  background-color: ${p => transparentize(0.1, p.theme.colors.primary)};
  display: flex;
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: 0;
  top: 0;
  right: 0;
  z-index: 999;
`;

const Content = styled.div`
  max-width: ${p => p.theme.globalWidthXSmall};
  text-align: center;
`;

const Menu = styled.nav`
  margin-bottom: 0;
`;

const NavElement = styled(Link)`
  color: ${p => p.theme.colors.headerFont};
  cursor: pointer;
  font-size: 2.5rem;
  display: block;
  text-decoration: none;
  padding: 15px 0;
  transition: 0.5s color;

  &:hover {
    color: ${p => darken(0.1, p.theme.colors.headerFont)};
  }
`;

class MobileNavigation extends Component {
  state = {
    isOpen: false
  };

  static propTypes = {
    left: PropTypes.array,
    right: PropTypes.array
  };

  static defaultProps = {
    left: [],
    right: []
  };

  componentDidMount = () => {
    document.addEventListener('keydown', this.handleKeyDown);
  };

  componentWillUnmount = () => {
    document.removeEventListener('keydown', this.handleKeyDown);
  };

  componentDidUpdate = () => {
    const { location, history } = this.props;

    history.listen(newLocation => {
      if (location.pathname !== newLocation.pathname) {
        this.setState({ isOpen: false });
      }
    });
  };

  handleKeyDown = event => {
    if (this.state.isOpen && event.key === 'Escape') {
      this.setState({ isOpen: false });
    }
  };

  toggleMenu = () => {
    this.setState(prev => ({
      isOpen: !prev.isOpen
    }));
  };

  render() {
    const { isOpen } = this.state;
    const { left, right } = this.props;

    const renderMenu = [...left, ...right].map(({ id, title, url }) => (
      <NavElement key={id} to={url}>
        {title}
      </NavElement>
    ));

    return (
      <StyledMobileNavigation>
        <Logo width="140px" height="32px" color="#ffffff" />

        <MenuButton onClick={this.toggleMenu} />

        <Overlay in={isOpen}>
          <Content>
            <HeaderCartController />

            <Menu>{renderMenu}</Menu>
          </Content>
        </Overlay>
      </StyledMobileNavigation>
    );
  }
}

export default withRouter(MobileNavigation);
